const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M7.098 8.536C7.134 8.512 9.702 8.5 14.802 8.5H22.434L23.172 10.48C23.292 10.804 23.418 11.152 23.55 11.524C23.694 11.896 23.796 12.172 23.856 12.352C23.916 12.52 23.958 12.64 23.982 12.712H23.622L23.262 12.694C22.998 11.998 22.572 11.392 21.984 10.876C21.408 10.348 20.742 9.964 19.986 9.724C19.326 9.496 18.384 9.34 17.16 9.256C16.8 9.232 14.994 9.22 11.742 9.22C10.11 9.22 9.294 9.226 9.294 9.238C9.33 9.274 10.32 10.63 12.264 13.306C14.208 15.97 15.186 17.314 15.198 17.338C15.27 17.446 15.282 17.536 15.234 17.608L8.682 25.366C9.942 25.378 11.22 25.384 12.516 25.384C13.092 25.384 13.71 25.384 14.37 25.384C15.03 25.384 15.582 25.378 16.026 25.366C16.47 25.366 16.716 25.366 16.764 25.366C18.036 25.318 19.05 25.186 19.806 24.97C21.15 24.586 22.164 23.854 22.848 22.774C22.968 22.582 23.106 22.288 23.262 21.892H23.982C23.802 22.408 23.544 23.176 23.208 24.196C22.872 25.216 22.614 25.978 22.434 26.482L14.802 26.5C9.714 26.5 7.152 26.488 7.116 26.464C7.044 26.44 7.008 26.386 7.008 26.302C7.008 26.266 7.026 26.224 7.062 26.176C7.074 26.152 7.632 25.486 8.736 24.178C9.84 22.87 10.944 21.562 12.048 20.254L13.704 18.292C13.704 18.28 12.588 16.744 10.356 13.684L7.026 9.094L7.008 8.896C7.008 8.704 7.038 8.584 7.098 8.536Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 4,
  height: 6,
  transform: "matrix(1 0 0 -1 14 34)",
  stroke: "#0081CC"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: -0.5,
  y: 0.5,
  width: 4,
  height: 6,
  transform: "matrix(1 0 0 -1 14 7)",
  stroke: "#0081CC"
});

const SvgEquationIntegrals2 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-2.c9cb1227.svg";
export { ForwardRef as ReactComponent };